module.exports = __webpack_public_path__ + "static/media/lightblue.cdbd7ec1.svg";